module.exports = __webpack_public_path__ + "img/refresh-icon.10645831.svg";